import { IconContext } from 'react-icons'
import { FaFacebookMessenger, FaXTwitter, FaLinkedinIn, FaWhatsapp, FaShareNodes } from 'react-icons/fa6'
import React, { useState } from 'react'

interface Props {
    config: any
}

export const ShareButton: React.FC<Props> = ({ config }) => {
    const { header_bg_color, header_button_text_color } = config
    const [showIcons, setShowIcons] = useState(false)

    const text = "I'm using the AccessAva chatbot!"
    const url = 'https://www.accesscharity.org.uk/'

    const message = encodeURIComponent(`${text} ${url}`)

    const handleWhatsAppShare = () => {
        window.open(`https://wa.me/?text=${message}`, '_blank')
    }

    const handleMessengerShare = () => {
        window.open(`fb-messenger://share/?link=${encodeURIComponent(url)}&app_id=YOUR_APP_ID`, '_blank')
    }

    const handleTwitterShare = () => {
        window.open(`https://twitter.com/intent/tweet?text=${message}`, '_blank')
    }

    const handleLinkedInShare = () => {
        window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`, '_blank')
    }

    return (
        <div
            className='buttonContainer'
            style={{ marginLeft: '5px' }}
        >
            <button
                style={{ color: header_button_text_color, backgroundColor: header_bg_color }}
                onClick={() => setShowIcons(!showIcons)}
            >
                <IconContext.Provider value={{ size: '1.2em' }}>
                    <div>
                        <FaShareNodes />
                    </div>
                </IconContext.Provider>
            </button>
            {showIcons && (
                <div style={{ display: 'flex', flexDirection: 'row', marginLeft: '10px' }}>
                    <button
                        style={{ color: header_button_text_color, backgroundColor: header_bg_color }}
                        onClick={handleMessengerShare}
                    >
                        <IconContext.Provider value={{ size: '1.2em', color: header_button_text_color }}>
                            <div>
                                <FaFacebookMessenger />
                            </div>
                        </IconContext.Provider>
                    </button>
                    <button
                        style={{ color: header_button_text_color, backgroundColor: header_bg_color }}
                        onClick={handleTwitterShare}
                    >
                        <IconContext.Provider value={{ size: '1.2em', color: header_button_text_color }}>
                            <div>
                                <FaXTwitter />
                            </div>
                        </IconContext.Provider>
                    </button>
                    <button
                        style={{ color: header_button_text_color, backgroundColor: header_bg_color }}
                        onClick={handleWhatsAppShare}
                    >
                        <IconContext.Provider value={{ size: '1.2em', color: header_button_text_color }}>
                            <div>
                                <FaWhatsapp />
                            </div>
                        </IconContext.Provider>
                    </button>
                    <button
                        style={{ color: header_button_text_color, backgroundColor: header_bg_color }}
                        onClick={handleLinkedInShare}
                    >
                        <IconContext.Provider value={{ size: '1.2em', color: header_button_text_color }}>
                            <div>
                                <FaLinkedinIn />
                            </div>
                        </IconContext.Provider>
                    </button>
                </div>
            )}
        </div>
    )
}
